/**************************************************
 * Nombre:       BarraProgreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Grid, LinearProgress, Typography} from "@mui/material";
import {NEGRITA} from "../../../../Constantes";
import {theme} from "../../../../Tema";
import {useEffect, useState} from "react";


const BarraProgreso = ({item}) => {
    const [progress, setProgress] = useState(0);


    useEffect(() =>{

        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;

                if (oldProgress >= item.porcentaje - 10) {
                    oldProgress = item.porcentaje
                    return oldProgress;
                }else {
                    return Math.min(oldProgress + diff, 100);
                }





            });
        }, 500);

        return () => {
            clearInterval(timer);
        };


    },[])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 22}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            px: 2,
                            py: 0.4,
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 600,
                            borderRadius: 1
                        }}>{item.porcentaje + '%'}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 1}}>
                    <Box sx={{width: '100%'}}>
                        <LinearProgress
                            variant="buffer"
                            value={progress}
                           // valueBuffer={buffer}
                            sx={{height: 10}}
                            aria-label="Loading…"
                        />
                    </Box>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraProgreso